import { format } from 'date-fns/format';

export function formatSlotTime(isoTime: string): string {
  try {
    return format(new Date(isoTime), 'h:mm a');
  } catch {
    return isoTime;
  }
}

export function formatDateForDisplay(date: Date) {
  return {
    dayOfWeek: format(date, 'EEE'),
    dayNumber: format(date, 'd'),
    month: format(date, 'MMM'),
  };
}
